// Data for Associazione Progetto Futuro - all real courses from the original site

export const siteInfo = {
  name: "Associazione Progetto Futuro",
  tagline: "Progettiamo un futuro sicuro!",
  subtitle: "Corsi di formazione professionale accreditati e certificazioni riconosciute a livello nazionale",
  phone: "+39 393 945 7831",
  email: "progettofuturoapf@gmail.com",
  address: "Vibo Valentia, Calabria, Italia",
  socials: {
    facebook: "https://facebook.com",
    instagram: "https://instagram.com",
    whatsapp: "https://wa.me/393939457831"
  }
};

export const categories = [
  {
    id: "sanitario",
    title: "Formazione Socio-Sanitaria",
    description: "Percorsi qualificanti per Operatori Socio Sanitari e figure specializzate nel supporto alla persona",
    icon: "Stethoscope",
    countLabel: "3 corsi"
  },
  {
    id: "eipass",
    title: "Certificazioni EIPASS",
    description: "Ei-Center Accreditato: certificazioni informatiche valide per graduatorie docenti e ATA",
    icon: "Laptop",
    countLabel: "5 certificazioni"
  },
  {
    id: "impianti",
    title: "Impianti e DM 37/08",
    description: "Corsi tecnici per installatori elettrici, elettronici, termoidraulici e fotovoltaici",
    icon: "Zap",
    countLabel: "6 corsi"
  },
  {
    id: "sicurezza",
    title: "Sicurezza sul Lavoro 81/08",
    description: "Formazione obbligatoria per lavoratori, preposti, dirigenti, RSPP, RLS, antincendio, primo soccorso, HACCP e aggiornamenti FER",
    icon: "HardHat",
    countLabel: "15 corsi"
  },
  {
    id: "ecm",
    title: "ECM — Educazione Continua in Medicina",
    description: "Corsi ECM accreditati per OSS, infermieri e professionisti sanitari con crediti validi per il triennio formativo",
    icon: "Stethoscope",
    countLabel: "2 corsi"
  },
  {
    id: "consulenza",
    title: "Consulenza Sicurezza e Igiene",
    description: "Consulenza specializzata in materia di sicurezza e igiene sui luoghi di lavoro",
    icon: "ShieldCheck",
    countLabel: "Servizio"
  },
  {
    id: "qualita",
    title: "Sistema Gestione Qualità ISO 9001",
    description: "Consulenza per l'implementazione dei sistemi di gestione della qualità",
    icon: "Award",
    countLabel: "Servizio"
  }
];

export const courses = [
  // ==================== SANITARIO ====================
  {
    id: "corso-oss",
    slug: "corso-oss",
    title: "Corso O.S.S.",
    fullTitle: "Operatore Socio Sanitario",
    category: "sanitario",
    duration: "1000 ore",
    theory: "450 ore",
    practice: "550 ore",
    price: "Rateizzabile",
    featured: true,
    tag: "Più richiesto",
    shortDescription: "Il corso per Operatore Socio Sanitario forma professionisti nell'ambito dell'assistenza socio-sanitaria in strutture ospedaliere, RSA e domicilio.",
    description: "Il corso per Operatore Socio Sanitario (OSS) è rivolto a tutti coloro che desiderano acquisire competenze professionali nell'ambito dell'assistenza socio-sanitaria. L'OSS svolge un ruolo fondamentale nella cura e nel supporto della persona, operando in strutture sanitarie, socio-assistenziali e domiciliari, in collaborazione con il personale medico e infermieristico.",
    modules: [
      { title: "Formazione in aula (450 ore)", detail: "Lezioni teoriche e pratiche tenute da docenti esperti, volte a fornire solide basi in ambito sanitario, igienico-assistenziale, psicologico e relazionale." },
      { title: "Tirocinio (550 ore)", detail: "Esperienza diretta all'interno dell'Ospedale di Vibo Valentia, che permette di mettere in pratica quanto appreso, confrontandosi con contesti reali e con il lavoro in équipe." }
    ],
    qualification: "Qualifica professionale di Operatore Socio Sanitario, valida su tutto il territorio nazionale ed europeo.",
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&q=80"
  },
  {
    id: "corso-osss",
    slug: "corso-osss",
    title: "Corso O.S.S.S",
    fullTitle: "OSS con Formazione Complementare in Assistenza Sanitaria",
    category: "sanitario",
    duration: "400 ore",
    theory: "200 ore",
    practice: "200 ore",
    price: "Rateizzabile",
    featured: true,
    tag: "Specializzazione",
    shortDescription: "Corso di specializzazione per OSS che desiderano ampliare le competenze nel supporto infermieristico avanzato.",
    description: "Il corso per OSSS (Operatore Socio Sanitario con formazione complementare in assistenza sanitaria) è rivolto a chi è già in possesso della qualifica di OSS e desidera ampliare le proprie competenze professionali nel supporto infermieristico, potenziando il proprio profilo nel settore sanitario.",
    modules: [
      { title: "Formazione in aula (200 ore)", detail: "Lezioni tenute da professionisti del settore, focalizzate su aspetti sanitari avanzati come somministrazione di terapie per via naturale, rilevazione dei parametri vitali, medicazioni semplici, assistenza pre e post-operatoria, mobilizzazione dei pazienti e collaborazione con l'equipe infermieristica." },
      { title: "Tirocinio (200 ore)", detail: "Esperienza pratica presso l'Ospedale di Vibo Valentia, per applicare direttamente le competenze apprese in contesti reali e strutturati." }
    ],
    qualification: "Qualifica di OSSS, equipollente alla figura di Assistente Infermieristico e riconosciuta a livello nazionale.",
    image: "https://images.unsplash.com/photo-1584515933487-779824d29309?w=800&q=80"
  },
  {
    id: "corso-asacom",
    slug: "corso-asacom",
    title: "Corso A.S.A.C.O.M.",
    fullTitle: "Assistente all'Autonomia e alla Comunicazione",
    category: "sanitario",
    duration: "600 ore",
    theory: "360 ore",
    practice: "240 ore",
    price: "Rateizzabile",
    featured: true,
    tag: "Nuovo",
    shortDescription: "Figura professionale specializzata nel supporto di persone con disabilità in ambito scolastico e socio-educativo.",
    description: "Il corso ASACOM è pensato per formare una figura professionale altamente specializzata, in grado di supportare persone con disabilità, soprattutto in ambito scolastico e socio-educativo, favorendone l'autonomia personale e la piena partecipazione alla vita quotidiana e sociale.",
    modules: [
      { title: "Teoria (360 ore)", detail: "Lezioni con docenti qualificati su psicopedagogia, disabilità sensoriali e cognitive, linguaggi alternativi e aumentativi, normativa di riferimento, metodologie educative e comunicazione inclusiva." },
      { title: "Stage (240 ore)", detail: "Esperienza diretta presso enti, scuole o strutture specializzate, per mettere in pratica le competenze acquisite e lavorare a fianco di professionisti del settore." }
    ],
    qualification: "Qualifica professionale di Assistente all'Autonomia e alla Comunicazione delle persone con disabilità (ASACOM), riconosciuta a livello nazionale.",
    image: "https://images.unsplash.com/photo-1544027993-37dbfe43562a?w=800&q=80"
  },

  // ==================== EIPASS ====================
  {
    id: "eipass-standard",
    slug: "eipass-standard",
    title: "EIPASS 7 Moduli Standard",
    fullTitle: "Certificazione Informatica Europea Standard",
    category: "eipass",
    duration: "Flessibile",
    theory: "7 moduli",
    practice: "Esame online",
    price: "Su richiesta",
    featured: true,
    tag: "Certificazione",
    shortDescription: "La certificazione EIPASS più richiesta per graduatorie docenti e concorsi pubblici.",
    description: "EIPASS 7 Moduli Standard è la certificazione che attesta il possesso delle competenze digitali indispensabili per operare in modo efficace nel mondo del lavoro moderno. Riconosciuta dal MIUR e valida come titolo culturale nei concorsi pubblici e nelle graduatorie scolastiche del personale docente e ATA.",
    modules: [
      { title: "7 Moduli Formativi", detail: "I fondamenti dell'ICT, Navigare e cercare informazioni sul Web, Comunicare in Rete, Sicurezza informatica, Elaborazione testi, Foglio di calcolo, Presentazione." },
      { title: "Esame Online", detail: "Test finale svolto interamente online presso il nostro Ei-Center accreditato, con rilascio immediato della certificazione." }
    ],
    qualification: "Certificazione EIPASS 7 Moduli Standard, riconosciuta dal MIUR e utilizzabile come titolo nelle graduatorie scolastiche e nei concorsi pubblici.",
    image: "https://images.unsplash.com/photo-1531403009284-440f080d1e12?w=800&q=80"
  },
  {
    id: "eipass-user",
    slug: "eipass-user",
    title: "EIPASS 7 Moduli User",
    fullTitle: "Certificazione EIPASS User",
    category: "eipass",
    duration: "Flessibile",
    theory: "7 moduli",
    practice: "Esame online",
    price: "Su richiesta",
    featured: false,
    tag: "Certificazione",
    shortDescription: "Certificazione informatica avanzata orientata all'uso professionale di suite office e strumenti collaborativi.",
    description: "EIPASS 7 Moduli User è la certificazione informatica che attesta un livello avanzato di competenze digitali applicate alla vita professionale, alla didattica e alla comunicazione. Perfetta per docenti, ATA, dipendenti pubblici e privati che vogliono valorizzare il proprio curriculum.",
    modules: [
      { title: "Contenuti dei 7 moduli", detail: "Fondamenti dell'ICT, Sicurezza informatica, Navigazione web, Comunicazione e collaborazione online, Elaborazione testi, Fogli di calcolo, Presentazioni multimediali." },
      { title: "Modalità e-learning", detail: "Studio in autonomia con piattaforma online, videolezioni ed esercitazioni pratiche. Esame presso il nostro Ei-Center accreditato." }
    ],
    qualification: "Certificazione EIPASS 7 Moduli User riconosciuta dal MIUR, valida come titolo culturale e per l'aggiornamento delle graduatorie del personale docente e ATA.",
    image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=800&q=80"
  },
  {
    id: "eipass-convalida",
    slug: "eipass-convalida-standard",
    title: "Convalida Standard",
    fullTitle: "EIPASS Alfabetizzazione Digitale",
    category: "eipass",
    duration: "Flessibile",
    theory: "4 moduli base",
    practice: "Esame online",
    price: "Su richiesta",
    featured: false,
    tag: "Alfabetizzazione",
    shortDescription: "Certificazione EIPASS delle competenze digitali di base per l'ingresso nel mondo del lavoro digitale.",
    description: "La Convalida Standard EIPASS è la certificazione che attesta il possesso delle competenze digitali essenziali per l'utilizzo quotidiano del computer, di internet e degli strumenti informatici di base. Ideale per chi desidera avvicinarsi al mondo del digitale in modo strutturato.",
    modules: [
      { title: "Moduli base", detail: "Uso del computer e gestione file, elaborazione testi, navigazione web sicura, posta elettronica e comunicazione online." },
      { title: "Percorso semplificato", detail: "Studio in autoapprendimento con materiale dedicato e supporto tutor. Esame online presso l'Ei-Center." }
    ],
    qualification: "Certificazione EIPASS Convalida Standard - Alfabetizzazione Digitale, riconosciuta e spendibile come titolo culturale.",
    image: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=800&q=80"
  },
  {
    id: "eipass-digcomp",
    slug: "eipass-digcomp-2-2",
    title: "EIPASS DigComp 2.2",
    fullTitle: "Certificazione Internazionale di Alfabetizzazione Digitale (CIAD)",
    category: "eipass",
    duration: "Flessibile",
    theory: "7 moduli · 4 livelli",
    practice: "Esame online",
    price: "Su richiesta",
    featured: true,
    tag: "Novità 2025",
    shortDescription: "La certificazione EIPASS aggiornata al framework europeo DigComp 2.2 e requisito CIAD per l'accesso alle graduatorie ATA di terza fascia.",
    description: "EIPASS DigComp 2.2 è la certificazione EIPASS Standard aggiornata al framework europeo DigComp 2.2, accreditata Accredia e riconosciuta come Certificazione Internazionale di Alfabetizzazione Digitale (CIAD). È requisito previsto dal CCNL Comparto Istruzione (Nota Congiunta n. 5 del 18 gennaio 2024) per l'accesso alle graduatorie ATA di terza fascia. La struttura a difficoltà crescente permette di attestare le proprie competenze digitali dal livello base fino all'altamente specializzato, coprendo tutte le 5 aree del DigComp 2.2.",
    modules: [
      { title: "5 aree del DigComp 2.2", detail: "Area 1 — Alfabetizzazione su informazioni e dati; Area 2 — Comunicazione e collaborazione; Area 3 — Creazione di contenuti digitali; Area 4 — Sicurezza; Area 5 — Risolvere problemi." },
      { title: "Struttura a livelli crescenti", detail: "Ogni modulo prevede 12 domande base, 11 intermedie, 9 avanzate e 4 altamente specializzate. Soglia minima 50% per superare il modulo, 75% per accedere al livello superiore. È possibile ottenere il titolo anche col solo livello base." },
      { title: "Esame integrativo per già certificati", detail: "Per chi possiede EIPASS 7 Moduli User (versione 5.0 o 6.0) è previsto un esame integrativo DigComp 2.2 di 56 domande in 90 minuti con soglia del 75%." }
    ],
    qualification: "Certificazione EIPASS DigComp 2.2 — CIAD, accreditata Accredia, valida 4 anni. Requisito per graduatorie ATA terza fascia e titolo culturale nei concorsi pubblici. Rinnovo mediante esame di 56 domande.",
    image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&q=80"
  },
  {
    id: "eipass-digcompedu",
    slug: "eipass-digcompedu",
    title: "EIPASS DigCompEdu",
    fullTitle: "Certificazione delle Competenze Digitali per Educatori (framework europeo DigCompEdu)",
    category: "eipass",
    duration: "Flessibile",
    theory: "6 moduli · livelli A1-C2",
    practice: "Esame online",
    price: "Su richiesta",
    featured: true,
    tag: "Per Docenti",
    shortDescription: "Certificazione EIPASS dedicata a docenti, formatori ed educatori, basata sul framework europeo DigCompEdu per le competenze digitali applicate all'insegnamento.",
    description: "EIPASS DigCompEdu è la certificazione accreditata Accredia progettata specificamente per docenti, formatori ed educatori di ogni ordine e grado (I e II ciclo). Basata sul framework europeo DigCompEdu — Digital Competence Framework for Educators, valida le competenze digitali applicate all'insegnamento andando oltre la semplice alfabetizzazione digitale. Ideale per arricchire il curriculum e ottenere punti nelle graduatorie GPS o nei concorsi pubblici.",
    modules: [
      { title: "6 aree di competenza DigCompEdu", detail: "1) Coinvolgimento e valorizzazione professionale; 2) Risorse digitali; 3) Pratiche di insegnamento e apprendimento; 4) Valutazione dell'apprendimento; 5) Valorizzazione delle potenzialità degli studenti; 6) Sviluppo delle competenze digitali degli studenti." },
      { title: "Sistema di valutazione a livelli A1-C2", detail: "Ogni modulo verifica la padronanza su livelli crescenti: 12 domande A1/A2, 10 domande B1/B2, 8 domande C1/C2. Soglia del 75% per accedere al livello successivo. Il certificato riporta il livello medio complessivo e lo Statement of Results dettagliato per area." },
      { title: "Risorse formative incluse", detail: "Il pacchetto comprende dispense, videolezioni ed esercitazioni illimitate. Esame in modalità concentrata o distribuita, online o in presenza presso il nostro Ei-Center autorizzato." }
    ],
    qualification: "Certificazione EIPASS DigCompEdu accreditata Accredia, valida 4 anni. Titolo culturale spendibile in graduatorie GPS, concorsi pubblici e curriculum. Verifica pubblica del titolo tramite banca dati Accredia.",
    image: "https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=800&q=80"
  },

  // ==================== IMPIANTI - DM 37/08 ====================
  {
    id: "impianti-elettrici",
    slug: "installazione-impianti-elettrici",
    title: "Impianti Elettrici — Lettera A",
    fullTitle: "Installazione e Manutenzione di Impianti Elettrici",
    category: "impianti",
    duration: "300 ore",
    theory: "Teoria + pratica",
    practice: "Laboratori",
    price: "Su richiesta",
    featured: true,
    tag: "DM 37/08 A",
    shortDescription: "Percorso accreditato per acquisire il titolo richiesto per la Lettera A del DM 37/08 e diventare tecnico elettricista certificato.",
    description: "Il percorso formativo accreditato ti permette di acquisire le competenze tecniche necessarie a lavorare nel settore dell'impiantistica elettrica, ambito Lettera A del DM 37/08. Diventerai un tecnico elettricista certificato, in grado di progettare, installare e manutenere impianti elettrici civili e industriali.",
    modules: [
      { title: "Parte teorica", detail: "Consolidamento delle competenze, normative sulla sicurezza sul luogo di lavoro, interpretazione degli schemi elettrici e dei progetti, valutazione dei guasti nell'impianto." },
      { title: "Parte pratica", detail: "Realizzazione ed installazione di impianti secondo normativa, riferimento al rischio elettrico (PES PAV PEI), pianificazione progetti con norme CEI, dimensionamento, protezione, verifica e manutenzione ordinaria e straordinaria." }
    ],
    qualification: "Attestato di qualifica professionale valido per l'acquisizione della Lettera A del DM 37/08 presso la Camera di Commercio.",
    image: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=800&q=80"
  },
  {
    id: "impianti-elettronici",
    slug: "installazione-impianti-elettronici",
    title: "Impianti Elettronici — Lettera B",
    fullTitle: "Installazione e Manutenzione di Impianti Elettronici",
    category: "impianti",
    duration: "300 ore",
    theory: "Teoria + pratica",
    practice: "Laboratori",
    price: "Su richiesta",
    featured: false,
    tag: "DM 37/08 B",
    shortDescription: "Corso accreditato per l'acquisizione delle competenze tecniche nel settore dell'impiantistica elettronica ambito Lettera B del DM 37/08.",
    description: "Il percorso formativo accreditato è volto all'acquisizione delle competenze tecniche nel settore dell'impiantistica elettronica, ambito Lettera B del DM 37/08. Il titolo è requisito per la Camera di Commercio per rilasciare le dichiarazioni di conformità degli impianti ai sensi del DM 37/08.",
    modules: [
      { title: "Impianti radiotelevisivi e antenne", detail: "Studio degli impianti elettronici per la gestione e distribuzione dei segnali TV, telefono e dati, inclusi impianti in fibra ottica e infrastrutture correlate." },
      { title: "Impianti di sicurezza e trasmissione", detail: "Componenti impiantistiche per trasmissione e ricezione di segnali e dati, impianti di sicurezza ad installazione fissa alimentati a tensione inferiore a 50V AC / 120V DC." }
    ],
    qualification: "Titolo di studio riconosciuto per l'acquisizione della Lettera B del DM 37/08 presso la Camera di Commercio.",
    image: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=800&q=80"
  },
  {
    id: "termo-idraulico",
    slug: "qualifica-termo-idraulico",
    title: "Qualifica Termo-Idraulico — Lettera C",
    fullTitle: "Attestato di Qualifica EQF 3 nel Settore Termoidraulico",
    category: "impianti",
    duration: "Corso completo",
    theory: "Teoria + laboratori",
    practice: "Esame regionale",
    price: "Su richiesta",
    featured: false,
    tag: "DM 37/08 C",
    shortDescription: "Attestato di qualifica professionale livello 3 EQF per operare in autonomia come tecnico termoidraulico e ottenere la Lettera C.",
    description: "Il corso accreditato è volto all'acquisizione dell'Attestato di qualifica professionale (livello 3 EQF) nel settore termoidraulico, titolo riconosciuto come requisito per richiedere la Lettera C del DM 37/08. Si rivolge a titolari, dipendenti di aziende e liberi professionisti che vogliono operare in autonomia nel settore termoidraulico.",
    modules: [
      { title: "Lezioni teoriche e pratiche", detail: "Percorso strutturato con esercitazioni nei nostri laboratori attrezzati, studio della normativa e delle tecniche di installazione, manutenzione e controllo degli impianti termoidraulici." },
      { title: "Esame con commissione regionale", detail: "Al termine del percorso, esame davanti a commissione regionale nominata secondo normativa. Rilascio dell'attestato di Qualifica professionale EQF 3." }
    ],
    qualification: "Attestato di Qualifica professionale EQF 3 riconosciuto da Ente Pubblico (L. 845/78 art. 14 e DM 37/08). Valido in Italia e in Europa.",
    image: "https://images.unsplash.com/photo-1585909695284-32d2985ac9c0?w=800&q=80"
  },
  {
    id: "fotovoltaico",
    slug: "impianti-fotovoltaici",
    title: "Impianti Fotovoltaici",
    fullTitle: "Installatore e Manutentore di Impianti Solari Fotovoltaici",
    category: "impianti",
    duration: "80 ore FER",
    theory: "Teoria",
    practice: "Esercitazioni",
    price: "Su richiesta",
    featured: true,
    tag: "Rinnovabili",
    shortDescription: "Formazione completa su impianti fotovoltaici grid-connected, stand-alone (off-grid) e ibridi per il mercato delle rinnovabili.",
    description: "Il corso di impianti fotovoltaici fornisce una formazione completa per i professionisti che desiderano specializzarsi nel settore dell'energia rinnovabile, garantendo una preparazione tecnica valida per lavorare su tutte le tipologie di impianti fotovoltaici per la produzione di energia elettrica.",
    modules: [
      { title: "Grid-Connected e Off-Grid", detail: "Impianti connessi alla rete elettrica nazionale con scambio energetico, impianti stand-alone (a isola) con batteria di accumulo e totale indipendenza dalla rete." },
      { title: "Impianti Ibridi", detail: "Sistemi collegati alla rete che producono energia anche in autonomia, accumulando l'eccedenza. I pannelli ibridi forniscono elettricità e calore per il riscaldamento dell'acqua sanitaria." }
    ],
    qualification: "Attestato FER (Fonti Energie Rinnovabili) per l'installazione e manutenzione di impianti solari fotovoltaici, valido su tutto il territorio nazionale.",
    image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?w=800&q=80"
  },
  {
    id: "fibra-ottica",
    slug: "fibra-ottica",
    title: "Fibra Ottica e Multiservizio",
    fullTitle: "Tecnico Giuntista di Fibra Ottica e Impianto Multiservizio",
    category: "impianti",
    duration: "Corso completo",
    theory: "Teoria + pratica",
    practice: "Laboratorio",
    price: "Su richiesta",
    featured: false,
    tag: "Telecomunicazioni",
    shortDescription: "Specializzazione per installatori nel settore delle telecomunicazioni e della fibra ottica, obbligatoria per la Lettera B aggiornata.",
    description: "Il corso per tecnico giuntista di fibra ottica e impianto multiservizio è volto a fornire le conoscenze e le competenze necessarie agli installatori che vogliono specializzarsi nell'ambito delle telecomunicazioni e della fibra ottica. Con le modifiche al DM 37/08 lettera B di dicembre 2022, l'impianto multiservizio riacquista valore obbligatorio.",
    modules: [
      { title: "Impianto multiservizio", detail: "Obbligatorio dal 2015 per gli edifici di nuova costruzione. Realizzazione dell'infrastruttura fisica, dichiarazione di conformità e schema progettuale obbligatori per i responsabili tecnici." },
      { title: "Giuntatura fibra ottica", detail: "Tecniche di giuntatura, testing e certificazione degli impianti in fibra ottica per telecomunicazioni residenziali e commerciali." }
    ],
    qualification: "Attestato di specializzazione come tecnico giuntista di fibra ottica e impianto multiservizio, valido secondo la normativa DM 37/08 lettera B.",
    image: "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=800&q=80"
  },
  {
    id: "conduttore-termici",
    slug: "conduttore-impianti-termici",
    title: "Conduttore Impianti Termici >232kW",
    fullTitle: "Patentino di Abilitazione di Secondo Grado",
    category: "impianti",
    duration: "Corso completo",
    theory: "Teoria",
    practice: "Verifica finale",
    price: "Su richiesta",
    featured: false,
    tag: "Patentino",
    shortDescription: "Percorso per l'acquisizione del patentino di secondo grado per la conduzione degli impianti termici di potenza superiore a 232 kW.",
    description: "Il percorso è stato ideato sulla base del D.Lgs. 152/2006 come modificato dal D.Lgs. 128/2010 (Conferenza delle Regioni e delle Province Autonome del 25 maggio 2011). Al termine del corso, previo superamento della prova di verifica finale, è rilasciato un attestato che consente di acquisire il patentino di abilitazione di secondo grado.",
    modules: [
      { title: "Conduzione impianti termici", detail: "Attività di conduzione degli impianti di potenza superiore a 232 kW. Interventi di attivazione e conduzione dell'impianto termico." },
      { title: "Efficienza e regolazione", detail: "Verifica dei parametri di regolazione, controllo dell'efficienza della centrale termica, funzionalità dei componenti e ottimizzazione dei consumi." }
    ],
    qualification: "Patentino di abilitazione di secondo grado alla conduzione degli impianti termici >232 kW, riconosciuto a livello nazionale.",
    image: "https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=800&q=80"
  },

  // ==================== SICUREZZA E FER ====================
  {
    id: "pes-pav-pei",
    slug: "corso-pes-pav-pei",
    title: "Corso PES PAV PEI",
    fullTitle: "Formazione per operatori a rischio elettrico — CEI 11-27",
    category: "sicurezza",
    duration: "16 ore",
    theory: "Teoria + pratica",
    practice: "Esame finale",
    price: "Su richiesta",
    featured: false,
    tag: "CEI 11-27",
    shortDescription: "Formazione obbligatoria per operatori che lavorano su impianti elettrici in tensione o fuori tensione secondo la norma CEI 11-27.",
    description: "PES PAV PEI è il corso per la formazione di operatori che si occupano di installazione e manutenzione su impianti elettrici in tensione o fuori tensione, secondo la norma CEI EN 50110-1. Il corso fa riferimento alla Norma CEI 11-27, 5° edizione, in vigore da ottobre 2021, che prevede che il datore di lavoro conferisca per iscritto la qualifica ad operare su impianti elettrici.",
    modules: [
      { title: "Persona Esperta (PES)", detail: "Profilo con istruzione, conoscenza ed esperienza tali da essere in grado di analizzare i rischi ed evitare i pericoli elettrici." },
      { title: "Persona Avvertita (PAV)", detail: "Profilo adeguatamente avvisato da personale esperto per essere in grado di evitare i pericoli che l'elettricità può creare." },
      { title: "Persona Idonea (PEI)", detail: "Profilo con una capacità tecnica tale da essere in grado di eseguire lavori sotto tensione in sicurezza." }
    ],
    qualification: "Attestato PES/PAV/PEI conforme alla Norma CEI 11-27 5° edizione, valido come qualifica scritta ai sensi della normativa vigente.",
    image: "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=800&q=80"
  },
  {
    id: "diisocianati",
    slug: "corso-diisocianati-reach",
    title: "Corso Diisocianati (REACH)",
    fullTitle: "Formazione obbligatoria REACH — Restrizione n. 74",
    category: "sicurezza",
    duration: "Modulare",
    theory: "Base / Intermedio / Avanzato",
    practice: "Esame finale",
    price: "Su richiesta",
    featured: false,
    tag: "REACH",
    shortDescription: "Corso obbligatorio per tutti i lavoratori che utilizzano prodotti contenenti diisocianati (schiume poliuretaniche, sigillanti, adesivi, vernici).",
    description: "I diisocianati sono componenti chimici che possono creare problemi di salute a chi li utilizza. Sono presenti in schiume poliuretaniche, sigillanti, adesivi, rivestimenti, prodotti compositi e vernici. Dal Regolamento REACH — Restrizione n. 74, tutti i lavoratori che utilizzano prodotti contenenti diisocianati sono obbligati a frequentare un corso di formazione.",
    modules: [
      { title: "Formazione generale", detail: "Rischi per la salute derivanti dall'esposizione ai diisocianati, proprietà chimico-fisiche, uso corretto dei DPI e misure di prevenzione." },
      { title: "Livelli di formazione", detail: "Formazione modulare base, intermedio e avanzato in base al livello di rischio dell'attività svolta, con esame di verifica finale." }
    ],
    qualification: "Attestato di formazione obbligatoria per l'uso dei diisocianati ai sensi del Regolamento REACH, Restrizione n. 74.",
    image: "https://images.unsplash.com/photo-1587293852726-70cdb56c2866?w=800&q=80"
  },
  {
    id: "fer-elettrico",
    slug: "fer-aggiornamento-elettrico",
    title: "FER Aggiornamento Elettrico",
    fullTitle: "Aggiornamento Triennale FER Elettrico — D.Lgs. 28/2011",
    category: "sicurezza",
    duration: "16 ore",
    theory: "E-learning",
    practice: "Esame finale",
    price: "Su richiesta",
    featured: false,
    tag: "Aggiornamento",
    shortDescription: "Aggiornamento triennale obbligatorio per il mantenimento dell'abilitazione FER elettrico su impianti da fonti rinnovabili.",
    description: "Il Corso di Aggiornamento FER Elettrico è obbligatorio per le imprese che hanno conseguito l'Attestato FER 80 ore e svolgono attività di installazione e manutenzione straordinaria di impianti energetici alimentati da energie rinnovabili. Ai sensi del D.Lgs. 28/2011, le imprese devono provvedere all'aggiornamento triennale.",
    modules: [
      { title: "E-learning online", detail: "Il corso è erogato online e può essere seguito comodamente dalla nostra piattaforma e-learning con materiale sempre disponibile." },
      { title: "Esame finale", detail: "Al termine del percorso, esame finalizzato al rinnovo dell'attestato di qualificazione professionale per l'abilitazione FER elettrico." }
    ],
    qualification: "Rinnovo dell'attestato di qualificazione professionale FER elettrico, valido per 3 anni secondo il D.Lgs. 28/2011.",
    image: "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?w=800&q=80"
  },
  {
    id: "fer-termico",
    slug: "fer-aggiornamento-termico",
    title: "FER Aggiornamento Termico",
    fullTitle: "Aggiornamento Triennale FER Termico — D.Lgs. 28/2011",
    category: "sicurezza",
    duration: "16 ore",
    theory: "E-learning",
    practice: "Esame finale",
    price: "Su richiesta",
    featured: false,
    tag: "Aggiornamento",
    shortDescription: "Aggiornamento triennale obbligatorio per il mantenimento della qualifica FER termico su impianti termici alimentati da energie rinnovabili.",
    description: "Il D.Lgs. 28/2011 prevede l'obbligo di aggiornamento professionale per tutte le imprese qualificate nell'attività di installazione e manutenzione straordinaria di impianti energetici alimentati da energie rinnovabili (FER). Ogni 3 anni tutti gli installatori qualificati devono seguire il percorso formativo di aggiornamento.",
    modules: [
      { title: "Piattaforma e-learning", detail: "Segui il corso online sulla nostra piattaforma e-learning con contenuti aggiornati alla normativa vigente." },
      { title: "Esame finale", detail: "Al termine dell'aggiornamento, esame finale per il rinnovo dell'attestato di qualificazione professionale abilitante FER termico." }
    ],
    qualification: "Rinnovo dell'attestato di qualificazione professionale FER termico, valido per 3 anni ai sensi del D.Lgs. 28/2011.",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80"
  },

  // ==================== 81/08 SOTTOCORSI ====================
  {
    id: "formazione-generale",
    slug: "formazione-generale-lavoratori",
    title: "Formazione Generale Lavoratori",
    fullTitle: "Formazione Generale — D.Lgs. 81/08 e Accordo Stato-Regioni",
    category: "sicurezza",
    duration: "4 ore",
    theory: "Aula / e-learning",
    practice: "Test finale",
    price: "Su richiesta",
    featured: false,
    tag: "Obbligatorio",
    shortDescription: "Modulo obbligatorio per tutti i neoassunti: concetti di rischio, danno, prevenzione e diritti-doveri dei soggetti aziendali.",
    description: "La formazione generale è il modulo di base obbligatorio per tutti i lavoratori ai sensi dell'Accordo Stato-Regioni del 21/12/2011 e del D.Lgs. 81/08. Fornisce i concetti fondamentali su rischio, danno, prevenzione, protezione, organizzazione della prevenzione aziendale, diritti e doveri dei soggetti aziendali.",
    modules: [
      { title: "Contenuti (4 ore)", detail: "Concetti di rischio, danno, prevenzione, protezione; organizzazione della prevenzione aziendale; diritti, doveri e sanzioni per i vari soggetti aziendali; organi di vigilanza, controllo e assistenza." },
      { title: "Modalità di erogazione", detail: "Corso disponibile in modalità aula tradizionale, videoconferenza sincrona o e-learning. Test finale con attestato immediato al superamento." }
    ],
    qualification: "Attestato di Formazione Generale valido per tutti i settori ai sensi dell'Accordo Stato-Regioni 21/12/2011.",
    image: "https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=800&q=80"
  },
  {
    id: "formazione-specifica-basso",
    slug: "formazione-specifica-rischio-basso",
    title: "Formazione Specifica — Rischio Basso",
    fullTitle: "Formazione Specifica Lavoratori — Rischio Basso",
    category: "sicurezza",
    duration: "4 ore",
    theory: "Aula / e-learning",
    practice: "Test finale",
    price: "Su richiesta",
    featured: false,
    tag: "81/08",
    shortDescription: "Formazione specifica per lavoratori di aziende classificate a rischio basso (uffici, commercio, servizi).",
    description: "Modulo di formazione specifica ai sensi dell'Accordo Stato-Regioni del 21/12/2011 per lavoratori di aziende classificate a rischio basso, come uffici, attività commerciali e servizi. Si integra alla formazione generale (4 ore).",
    modules: [
      { title: "Contenuti (4 ore)", detail: "Rischi specifici del settore, videoterminali, movimentazione carichi leggeri, stress lavoro-correlato, rischio elettrico generico, emergenze e comportamenti di sicurezza." },
      { title: "Aggiornamento", detail: "Aggiornamento quinquennale obbligatorio di 6 ore per mantenere la validità dell'attestato." }
    ],
    qualification: "Attestato di Formazione Specifica Rischio Basso conforme all'Accordo Stato-Regioni 21/12/2011.",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80"
  },
  {
    id: "formazione-specifica-medio",
    slug: "formazione-specifica-rischio-medio",
    title: "Formazione Specifica — Rischio Medio",
    fullTitle: "Formazione Specifica Lavoratori — Rischio Medio",
    category: "sicurezza",
    duration: "8 ore",
    theory: "Aula",
    practice: "Test finale",
    price: "Su richiesta",
    featured: false,
    tag: "81/08",
    shortDescription: "Formazione specifica per lavoratori di aziende classificate a rischio medio (agricoltura, pesca, PA, sanità, trasporti).",
    description: "Modulo di formazione specifica per lavoratori di aziende classificate a rischio medio come agricoltura, pesca, pubblica amministrazione, sanità, trasporti e magazzinaggio. Si integra alla formazione generale (4 ore).",
    modules: [
      { title: "Contenuti (8 ore)", detail: "Rischi meccanici, elettrici, chimici, biologici, movimentazione manuale carichi, rumore, vibrazioni, DPI, segnaletica, procedure di sicurezza e gestione emergenze." },
      { title: "Aggiornamento", detail: "Aggiornamento quinquennale obbligatorio di 6 ore." }
    ],
    qualification: "Attestato di Formazione Specifica Rischio Medio conforme all'Accordo Stato-Regioni 21/12/2011.",
    image: "https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=800&q=80"
  },
  {
    id: "formazione-specifica-alto",
    slug: "formazione-specifica-rischio-alto",
    title: "Formazione Specifica — Rischio Alto",
    fullTitle: "Formazione Specifica Lavoratori — Rischio Alto",
    category: "sicurezza",
    duration: "12 ore",
    theory: "Aula",
    practice: "Test finale",
    price: "Su richiesta",
    featured: false,
    tag: "81/08",
    shortDescription: "Formazione specifica per lavoratori di aziende classificate a rischio alto (edilizia, chimica, siderurgia, sanità ospedaliera).",
    description: "Modulo di formazione specifica per lavoratori di aziende classificate a rischio alto come edilizia, industria chimica, siderurgia, estrazione minerali, sanità ospedaliera e gestione rifiuti. Si integra alla formazione generale (4 ore).",
    modules: [
      { title: "Contenuti (12 ore)", detail: "Rischi meccanici, elettrici, chimici, biologici avanzati; lavoro in quota, spazi confinati, ATEX; movimentazione carichi pesanti; DPI di III categoria; procedure operative di sicurezza." },
      { title: "Aggiornamento", detail: "Aggiornamento quinquennale obbligatorio di 6 ore." }
    ],
    qualification: "Attestato di Formazione Specifica Rischio Alto conforme all'Accordo Stato-Regioni 21/12/2011.",
    image: "https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=800&q=80"
  },
  {
    id: "preposto",
    slug: "corso-preposto",
    title: "Corso Preposto",
    fullTitle: "Formazione Preposto — Art. 37 D.Lgs. 81/08",
    category: "sicurezza",
    duration: "8 ore",
    theory: "Aula",
    practice: "Test finale",
    price: "Su richiesta",
    featured: false,
    tag: "Preposto",
    shortDescription: "Formazione particolare aggiuntiva per il preposto ai sensi dell'art. 37 comma 7 del D.Lgs. 81/08.",
    description: "Corso obbligatorio per la formazione particolare aggiuntiva del preposto ai sensi dell'art. 37 comma 7 del D.Lgs. 81/08. Il preposto vigila sull'osservanza degli obblighi di sicurezza da parte dei lavoratori.",
    modules: [
      { title: "Contenuti (8 ore)", detail: "Ruolo e responsabilità del preposto, principali soggetti coinvolti nel sistema di prevenzione, relazioni tra i vari soggetti aziendali, definizione di infortunio e malattia professionale, tecniche di comunicazione e sensibilizzazione dei lavoratori." },
      { title: "Aggiornamento", detail: "Aggiornamento quinquennale di almeno 6 ore obbligatorio." }
    ],
    qualification: "Attestato di Preposto conforme all'Accordo Stato-Regioni 21/12/2011 e art. 37 D.Lgs. 81/08.",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80"
  },
  {
    id: "dirigente",
    slug: "corso-dirigente",
    title: "Corso Dirigente",
    fullTitle: "Formazione Dirigente — Art. 37 D.Lgs. 81/08",
    category: "sicurezza",
    duration: "16 ore",
    theory: "Aula",
    practice: "Test finale",
    price: "Su richiesta",
    featured: false,
    tag: "Dirigente",
    shortDescription: "Formazione per dirigenti ai sensi dell'art. 37 comma 7 del D.Lgs. 81/08, con 4 moduli tematici.",
    description: "Corso obbligatorio per la formazione dei dirigenti in materia di salute e sicurezza sul lavoro ai sensi dell'art. 37 comma 7 del D.Lgs. 81/08 e dell'Accordo Stato-Regioni del 21/12/2011.",
    modules: [
      { title: "4 moduli tematici (16 ore)", detail: "Modulo 1 — Giuridico normativo; Modulo 2 — Gestione ed organizzazione della sicurezza; Modulo 3 — Individuazione e valutazione dei rischi; Modulo 4 — Comunicazione, formazione e consultazione dei lavoratori." },
      { title: "Aggiornamento", detail: "Aggiornamento quinquennale obbligatorio di 6 ore." }
    ],
    qualification: "Attestato di Dirigente per la Sicurezza conforme all'Accordo Stato-Regioni 21/12/2011.",
    image: "https://images.unsplash.com/photo-1553877522-43269d4ea984?w=800&q=80"
  },
  {
    id: "rspp-datore",
    slug: "rspp-datore-di-lavoro",
    title: "RSPP Datore di Lavoro",
    fullTitle: "Responsabile Servizio Prevenzione e Protezione — Datore di Lavoro",
    category: "sicurezza",
    duration: "16/32/48 ore",
    theory: "Aula",
    practice: "Test finale",
    price: "Su richiesta",
    featured: false,
    tag: "RSPP",
    shortDescription: "Corso per Datori di Lavoro che intendono svolgere direttamente il ruolo di RSPP nella propria azienda.",
    description: "Corso di formazione per Datori di Lavoro che intendono svolgere direttamente i compiti di Responsabile del Servizio di Prevenzione e Protezione (RSPP) nella propria azienda, ai sensi dell'art. 34 del D.Lgs. 81/08 e dell'Accordo Stato-Regioni del 21/12/2011.",
    modules: [
      { title: "Durata in base al rischio", detail: "16 ore per aziende a rischio basso, 32 ore per rischio medio, 48 ore per rischio alto. Contenuti su normativa, valutazione rischi, sistema prevenzionistico, comunicazione e gestione." },
      { title: "Aggiornamento", detail: "Aggiornamento quinquennale obbligatorio: 6 ore (basso), 10 ore (medio), 14 ore (alto)." }
    ],
    qualification: "Attestato RSPP Datore di Lavoro conforme all'Accordo Stato-Regioni 21/12/2011 e art. 34 D.Lgs. 81/08.",
    image: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=800&q=80"
  },
  {
    id: "rls",
    slug: "corso-rls",
    title: "Corso RLS",
    fullTitle: "Rappresentante dei Lavoratori per la Sicurezza",
    category: "sicurezza",
    duration: "32 ore",
    theory: "Aula",
    practice: "Test finale",
    price: "Su richiesta",
    featured: false,
    tag: "RLS",
    shortDescription: "Formazione per il Rappresentante dei Lavoratori per la Sicurezza (RLS) ai sensi dell'art. 37 D.Lgs. 81/08.",
    description: "Corso di formazione obbligatorio per il Rappresentante dei Lavoratori per la Sicurezza (RLS), figura eletta o designata dai lavoratori per rappresentarli in materia di salute e sicurezza sul lavoro, ai sensi dell'art. 37 del D.Lgs. 81/08.",
    modules: [
      { title: "Contenuti (32 ore)", detail: "Principi giuridici comunitari e nazionali, legislazione sicurezza, soggetti del sistema di prevenzione, definizione e individuazione dei fattori di rischio, valutazione dei rischi, tecniche di comunicazione." },
      { title: "Aggiornamento annuale", detail: "Aggiornamento annuale obbligatorio: 4 ore per aziende fino a 50 dipendenti, 8 ore per aziende con oltre 50 dipendenti." }
    ],
    qualification: "Attestato RLS conforme all'art. 37 D.Lgs. 81/08.",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80"
  },
  {
    id: "antincendio",
    slug: "corso-addetto-antincendio",
    title: "Addetto Antincendio",
    fullTitle: "Formazione Addetto Antincendio — DM 02/09/2021",
    category: "sicurezza",
    duration: "4 / 8 / 16 ore",
    theory: "Aula + esercitazioni",
    practice: "Prova pratica",
    price: "Su richiesta",
    featured: false,
    tag: "Antincendio",
    shortDescription: "Formazione per Addetti alla Gestione dell'Emergenza e prevenzione incendi secondo il DM 02/09/2021.",
    description: "Corso obbligatorio per gli Addetti alla Prevenzione Incendi, Lotta Antincendio e Gestione dell'Emergenza, ai sensi del DM 02/09/2021 (in vigore dal 4 ottobre 2022) e del D.Lgs. 81/08. Rilascia attestato con prova pratica di spegnimento.",
    modules: [
      { title: "3 livelli di rischio", detail: "Livello 1 - rischio basso (4 ore), Livello 2 - rischio medio (8 ore), Livello 3 - rischio alto (16 ore con esame presso VVF)." },
      { title: "Prova pratica", detail: "Esercitazione pratica di spegnimento con estintori e manichetta antincendio, gestione dell'evacuazione." }
    ],
    qualification: "Attestato di Addetto Antincendio secondo DM 02/09/2021, valido come idoneità tecnica per il livello di rischio corrispondente.",
    image: "https://images.unsplash.com/photo-1599700403969-f77b3aa74837?w=800&q=80"
  },
  {
    id: "primo-soccorso",
    slug: "corso-primo-soccorso",
    title: "Addetto Primo Soccorso",
    fullTitle: "Formazione Addetto Primo Soccorso — DM 388/2003",
    category: "sicurezza",
    duration: "12 / 16 ore",
    theory: "Aula + esercitazioni",
    practice: "Manovre pratiche",
    price: "Su richiesta",
    featured: false,
    tag: "Primo Soccorso",
    shortDescription: "Formazione per Addetti al Primo Soccorso Aziendale secondo il DM 388/2003 - Gruppi A, B, C.",
    description: "Corso obbligatorio per gli Addetti al Primo Soccorso Aziendale ai sensi del DM 388/2003 e del D.Lgs. 81/08. Formazione classificata in base al gruppo di rischio dell'azienda con esercitazioni pratiche.",
    modules: [
      { title: "Durata in base al gruppo", detail: "Gruppo A (16 ore) per aziende ad alto rischio; Gruppi B e C (12 ore) per aziende a medio e basso rischio. Contenuti su BLS-D, gestione emergenze sanitarie, traumi." },
      { title: "Aggiornamento triennale", detail: "Aggiornamento triennale obbligatorio: 6 ore per Gruppo A, 4 ore per Gruppi B e C." }
    ],
    qualification: "Attestato di Addetto Primo Soccorso conforme al DM 388/2003 - Gruppo di appartenenza.",
    image: "https://images.unsplash.com/photo-1584515933487-779824d29309?w=800&q=80"
  },
  {
    id: "haccp",
    slug: "corso-haccp",
    title: "Corso HACCP",
    fullTitle: "Attestato di Formazione HACCP — Reg. CE 852/2004",
    category: "sicurezza",
    duration: "6 / 12 ore",
    theory: "Aula / e-learning",
    practice: "Test finale",
    price: "Su richiesta",
    featured: false,
    tag: "HACCP",
    shortDescription: "Formazione obbligatoria HACCP per tutti gli operatori del settore alimentare (ex libretto sanitario).",
    description: "Corso di formazione HACCP obbligatorio per tutti gli operatori del settore alimentare (OSA) ai sensi del Reg. CE 852/2004 e del Reg. CE 178/2002. Sostituisce il vecchio libretto sanitario e rilascia attestato valido su tutto il territorio nazionale.",
    modules: [
      { title: "Livelli di formazione", detail: "6 ore per operatori del settore alimentare che non manipolano direttamente alimenti (camerieri, addetti al carico); 12 ore per addetti alla manipolazione di alimenti (cuochi, banconisti, pasticceri)." },
      { title: "Contenuti", detail: "Sistema HACCP, principi di igiene degli alimenti, contaminazioni biologiche/chimiche/fisiche, temperature di conservazione, allergeni, pulizia e sanificazione." }
    ],
    qualification: "Attestato HACCP conforme al Reg. CE 852/2004, valido su tutto il territorio nazionale con validità triennale.",
    image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&q=80"
  },

  // ==================== ECM (Educazione Continua in Medicina) ====================
  {
    id: "ecm-oss",
    slug: "ecm-oss",
    title: "ECM Aggiornamento OSS",
    fullTitle: "Educazione Continua in Medicina — Operatori Socio Sanitari",
    category: "ecm",
    duration: "Modulare",
    theory: "E-learning / FAD",
    practice: "Questionario ECM",
    price: "Su richiesta",
    featured: false,
    tag: "ECM",
    shortDescription: "Crediti formativi ECM per Operatori Socio Sanitari (OSS) e figure di supporto in ambito sanitario.",
    description: "Corsi di aggiornamento e formazione continua per Operatori Socio Sanitari (OSS) e figure di supporto in ambito sanitario, con rilascio di crediti ECM (Educazione Continua in Medicina) obbligatori per l'esercizio della professione.",
    modules: [
      { title: "FAD e Aula", detail: "Corsi disponibili in modalità FAD (Formazione a Distanza) ed in aula, con crediti ECM riconosciuti dal Ministero della Salute e AGENAS." },
      { title: "Temi trattati", detail: "Assistenza al paziente cronico, geriatria e dementia care, gestione dei farmaci, movimentazione del paziente, comunicazione con l'utente, sicurezza in ambito sanitario." }
    ],
    qualification: "Crediti ECM validi per il triennio formativo del Ministero della Salute, riconosciuti come aggiornamento obbligatorio della professione.",
    image: "https://images.unsplash.com/photo-1666214280138-1c1d63a0fd93?w=800&q=80"
  },
  {
    id: "ecm-infermieri",
    slug: "ecm-infermieri",
    title: "ECM Infermieri",
    fullTitle: "Educazione Continua in Medicina — Infermieri",
    category: "ecm",
    duration: "Modulare",
    theory: "E-learning / FAD",
    practice: "Questionario ECM",
    price: "Su richiesta",
    featured: false,
    tag: "ECM",
    shortDescription: "Percorsi ECM accreditati per infermieri professionali con crediti validi per il triennio formativo.",
    description: "Corsi di formazione continua accreditati ECM per Infermieri, Infermieri Pediatrici e Ostetriche. Percorsi FAD (Formazione a Distanza) e residenziali su tematiche cliniche, assistenziali e organizzative.",
    modules: [
      { title: "Aree tematiche", detail: "Nursing avanzato, wound care, gestione del dolore, farmacologia, emergenza-urgenza, cronicità, salute mentale, sanità digitale, comunicazione e leadership infermieristica." },
      { title: "Modalità e crediti", detail: "Corsi FAD asincroni con accreditamento AGENAS, questionari online per il rilascio dei crediti ECM. Attestati con crediti in base alle ore formative." }
    ],
    qualification: "Crediti ECM per Infermieri validi per il triennio formativo del Ministero della Salute.",
    image: "https://images.unsplash.com/photo-1631815588090-d4bfec5b1ccb?w=800&q=80"
  }
];

export const stats = [
  { value: "500+", label: "Studenti Formati" },
  { value: "15+", label: "Anni di Esperienza" },
  { value: "98%", label: "Tasso di Successo" },
  { value: "25+", label: "Docenti Qualificati" }
];

export const testimonials = [
  {
    name: "Maria Rossi",
    role: "Diplomata OSS 2024",
    text: "Un percorso formativo eccezionale. I docenti sono preparatissimi e il tirocinio in ospedale mi ha dato le competenze pratiche di cui avevo bisogno. Ora lavoro in una RSA e sono felicissima.",
    rating: 5,
    photo: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&q=80",
    date: "2 mesi fa",
    verified: true
  },
  {
    name: "Luca Bianchi",
    role: "Certificato EIPASS",
    text: "Ho ottenuto la certificazione EIPASS 7 Moduli in poche settimane. Grazie a questa qualifica ho ottenuto punti aggiuntivi nella graduatoria docenti. Consigliatissimo!",
    rating: 5,
    photo: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&q=80",
    date: "3 mesi fa",
    verified: true
  },
  {
    name: "Giulia Ferrari",
    role: "Diplomata ASACOM",
    text: "Il corso ASACOM mi ha aperto un mondo. Ora lavoro nelle scuole come assistente e sto realizzando la mia vocazione. L'associazione è seria e professionale.",
    rating: 5,
    photo: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&q=80",
    date: "1 mese fa",
    verified: true
  },
  {
    name: "Antonio Grasso",
    role: "Corso Impianti Elettrici — Lettera A",
    text: "Docenti competentissimi e disponibili anche fuori orario. Grazie a questo corso ho aperto la mia partita IVA come elettricista. Consigliato al 100%.",
    rating: 5,
    photo: null,
    date: "3 settimane fa",
    verified: true
  },
  {
    name: "Francesca Marino",
    role: "Corso OSS 2023",
    text: "Ambiente accogliente, materiali forniti gratuitamente, tirocinio ben organizzato all'ospedale di Vibo. La segreteria è sempre disponibile e chiara sui costi.",
    rating: 5,
    photo: null,
    date: "5 mesi fa",
    verified: true
  },
  {
    name: "Domenico Pugliese",
    role: "Corso Sicurezza 81/08 - Preposto",
    text: "Formazione di alta qualità, docenti che sanno spiegare e mettere a proprio agio. Perfetto per chi lavora già e deve aggiornarsi. Prezzo onesto.",
    rating: 5,
    photo: null,
    date: "1 settimana fa",
    verified: true
  },
  {
    name: "Sara Colombo",
    role: "Corso ASACOM 2024",
    text: "Esperienza formativa che mi ha cambiato la vita. Grazie a Progetto Futuro ora lavoro in una scuola come assistente educativa. Vi consiglio davvero di provare.",
    rating: 5,
    photo: null,
    date: "2 mesi fa",
    verified: true
  },
  {
    name: "Giovanni Romeo",
    role: "Corso Fotovoltaico FER",
    text: "Corso pratico, aggiornato con le ultime normative sulle rinnovabili. Ho ottenuto l'attestato in tempi rapidi e ora installo pannelli solari come tecnico certificato.",
    rating: 5,
    photo: null,
    date: "4 mesi fa",
    verified: true
  }
];

export const googleBusinessInfo = {
  rating: 5.0,
  reviewCount: 11,
  profileUrl: "https://www.google.com/maps/search/?api=1&query=Associazione+Progetto+Futuro+Vibo+Valentia",
  writeReviewUrl: "https://www.google.com/maps/search/?api=1&query=Associazione+Progetto+Futuro+Vibo+Valentia"
};

// Rolling deadline: 45 days from build time
const _d = new Date(); _d.setDate(_d.getDate() + 45);
export const enrollmentDeadline = _d.toISOString();

export const faqs = [
  {
    q: "I corsi sono riconosciuti a livello nazionale?",
    a: "Sì, tutti i nostri corsi rilasciano qualifiche professionali riconosciute a livello nazionale ed europeo, previo superamento dell'esame finale."
  },
  {
    q: "È possibile pagare a rate?",
    a: "Assolutamente sì. Tutti i corsi sono pagabili in comode rate, per rendere la formazione accessibile a tutti."
  },
  {
    q: "Dove si svolge il tirocinio?",
    a: "Il tirocinio per i corsi OSS e OSSS si svolge presso l'Ospedale di Vibo Valentia. Per il corso ASACOM il tirocinio avviene in scuole ed enti convenzionati. I corsi tecnici prevedono esercitazioni nei nostri laboratori."
  },
  {
    q: "Come posso richiedere informazioni?",
    a: "Compila il modulo di richiesta informazioni sul sito oppure chiamaci direttamente. Un operatore ti ricontatterà entro 48 ore con tutti i dettagli su costi, calendario e modalità di iscrizione."
  },
  {
    q: "Ci sono requisiti minimi per accedere ai corsi?",
    a: "I requisiti variano in base al corso. In generale è richiesto il diploma di scuola secondaria di primo grado e la maggiore età. Per corsi di specializzazione come OSSS è richiesta la qualifica OSS. Per i corsi tecnici DM 37/08 si valutano titolo di studio ed esperienza."
  },
  {
    q: "I corsi EIPASS sono validi per le graduatorie?",
    a: "Sì. EIPASS 7 Moduli Standard e User sono riconosciuti dal MIUR e valgono come titolo culturale per le graduatorie del personale docente e ATA, oltre che nei concorsi pubblici."
  }
];

export const partners = [
  { name: "MIUR", subtitle: "Riconoscimento", icon: "GraduationCap" },
  { name: "EIPASS", subtitle: "Ei-Center Accreditato", icon: "Laptop" },
  { name: "ISO 9001", subtitle: "Gestione Qualità", icon: "Award" },
  { name: "D.Lgs. 81/08", subtitle: "Sicurezza Lavoro", icon: "ShieldCheck" },
  { name: "DM 37/08", subtitle: "Impiantistica", icon: "Zap" },
  { name: "Accordo Stato-Regioni", subtitle: "21/12/2011", icon: "FileCheck" }
];

export const howItWorks = [
  {
    step: "01",
    title: "Scegli il corso",
    description: "Sfoglia il nostro catalogo di oltre 29 corsi accreditati e trova quello più adatto ai tuoi obiettivi professionali.",
    icon: "Search"
  },
  {
    step: "02",
    title: "Richiedi info",
    description: "Compila il modulo di richiesta informazioni. Un operatore ti ricontatterà entro 48 ore con tutti i dettagli.",
    icon: "MessageSquare"
  },
  {
    step: "03",
    title: "Frequenta e impara",
    description: "Segui le lezioni con docenti esperti e vivi esperienze pratiche di tirocinio in strutture reali.",
    icon: "BookOpen"
  },
  {
    step: "04",
    title: "Ottieni la qualifica",
    description: "Supera l'esame finale e ricevi la tua qualifica professionale riconosciuta a livello nazionale ed europeo.",
    icon: "Trophy"
  }
];

export const team = [
  {
    name: "Dott.ssa Anna Marino",
    role: "Direttrice Didattica",
    bio: "Laureata in Scienze Infermieristiche, con oltre 15 anni di esperienza nella formazione socio-sanitaria.",
    photo: "https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=400&q=80"
  },
  {
    name: "Ing. Marco De Luca",
    role: "Responsabile Formazione Tecnica",
    bio: "Ingegnere elettrico e formatore certificato per corsi DM 37/08 e sicurezza sul lavoro.",
    photo: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&q=80"
  },
  {
    name: "Prof.ssa Laura Bianchi",
    role: "Coordinatrice EIPASS",
    bio: "Referente per l'Ei-Center accreditato, specializzata in didattica digitale e alfabetizzazione informatica.",
    photo: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&q=80"
  },
  {
    name: "Dott. Giuseppe Costa",
    role: "Responsabile Tirocini",
    bio: "Coordinatore dei tirocini presso l'Ospedale di Vibo Valentia e le strutture partner del territorio.",
    photo: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=400&q=80"
  }
];

export const news = [
  {
    id: "news-1",
    title: "Aperte le iscrizioni al nuovo corso OSS 2025",
    excerpt: "Ultimi posti disponibili per il corso di Operatore Socio Sanitario da 1000 ore. Tirocinio all'Ospedale di Vibo Valentia.",
    date: "15 Luglio 2025",
    category: "Iscrizioni",
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=600&q=80"
  },
  {
    id: "news-2",
    title: "Nuovo aggiornamento EIPASS per graduatorie ATA",
    excerpt: "Con la certificazione EIPASS 7 Moduli Standard puoi ottenere punti aggiuntivi nelle graduatorie del personale ATA.",
    date: "8 Luglio 2025",
    category: "EIPASS",
    image: "https://images.unsplash.com/photo-1531403009284-440f080d1e12?w=600&q=80"
  },
  {
    id: "news-3",
    title: "DM 02/09/2021: obblighi antincendio aggiornati",
    excerpt: "Tutti gli addetti antincendio devono aggiornare la formazione secondo il nuovo decreto. Scopri come.",
    date: "1 Luglio 2025",
    category: "Sicurezza",
    image: "https://images.unsplash.com/photo-1599700403969-f77b3aa74837?w=600&q=80"
  }
];

// Career outcomes per course (used on CourseDetail page)
export const careerOutcomes = {
  "corso-oss": [
    "Case di riposo e RSA",
    "Ospedali e strutture sanitarie",
    "Assistenza domiciliare",
    "Centri diurni e comunità"
  ],
  "corso-osss": [
    "Reparti ospedalieri",
    "Cliniche private",
    "Servizi infermieristici territoriali",
    "Strutture di lungodegenza"
  ],
  "corso-asacom": [
    "Scuole di ogni ordine e grado",
    "Cooperative sociali",
    "Centri diurni per disabili",
    "Servizi educativi territoriali"
  ],
  "eipass-standard": [
    "Graduatorie docenti (punti aggiuntivi)",
    "Graduatorie personale ATA",
    "Concorsi pubblici",
    "Titolo culturale certificato"
  ],
  "eipass-user": [
    "Aggiornamento graduatorie scolastiche",
    "Uso professionale suite office",
    "Ambiti amministrativi",
    "Concorsi pubblici"
  ],
  "installazione-impianti-elettrici": [
    "Lettera A DM 37/08 in CCIAA",
    "Tecnico elettricista autonomo",
    "Impianti civili e industriali",
    "Aziende del settore elettrico"
  ],
  "installazione-impianti-elettronici": [
    "Lettera B DM 37/08 in CCIAA",
    "Tecnico antenne e TVCC",
    "Impianti radiotelevisivi",
    "Sistemi di sicurezza e allarme"
  ],
  "qualifica-termo-idraulico": [
    "Lettera C DM 37/08 in CCIAA",
    "Idraulico certificato",
    "Manutentore caldaie e impianti",
    "Libero professionista"
  ],
  "impianti-fotovoltaici": [
    "Installatore FER accreditato",
    "Aziende energie rinnovabili",
    "Manutentore fotovoltaico",
    "Consulente energetico"
  ],
  "corso-haccp": [
    "Ristorazione (chef, camerieri, banconisti)",
    "Bar, pasticcerie, gelaterie",
    "Alberghi e strutture ricettive",
    "Industria alimentare"
  ]
};

export const courseFAQs = [
  {
    q: "Il corso rilascia una qualifica riconosciuta?",
    a: "Sì, al superamento dell'esame finale ottieni una qualifica professionale valida a livello nazionale ed europeo."
  },
  {
    q: "È possibile pagare a rate?",
    a: "Certamente. Il corso è pagabile in comode rate mensili concordate con la segreteria."
  },
  {
    q: "Come vengono organizzate le lezioni?",
    a: "Le lezioni si svolgono in aula con docenti esperti, integrate da tirocinio o esercitazioni pratiche nei nostri laboratori."
  }
];
